import { useMemo } from "react";

import {
    useIsStandardToPremiumUpgradeEligible,
    useUpgradableSites,
    useUpgradableStandardSites
} from "@/components/user-context/helpers/cohorts";

/**
 * Returns existing sites for users eligible for the standard-to-premium upgrade path.
 * @returns {ExistingSite[] | undefined} The existing sites or undefined
 */
export function useGetExistingSites() {
    const isStandardToPremiumUpgradeEligible =
        useIsStandardToPremiumUpgradeEligible();
    const upgradeableStandardSites = useUpgradableStandardSites();
    const upgradableSites = useUpgradableSites();

    return useMemo(() => {
        return isStandardToPremiumUpgradeEligible
            ? [...(upgradeableStandardSites ?? []), ...(upgradableSites ?? [])]
            : undefined;
    }, [
        isStandardToPremiumUpgradeEligible,
        upgradeableStandardSites,
        upgradableSites
    ]);
}
